import request from '../../axios/axiosconfig.js'

export function getStoreStatics(params) {
  return request({
    url: '/ps/storeStatistics/storeStatistics',
    method: 'get',
    params: params,
    timeout: 20000
  })
}
export function getStoreRank() {
    return request({
      url: '/ps/storeStatistics/getStoreRank',
      method: 'get',
      timeout: 20000
    })
  }
  export function getAreaStoreAndDevice() {
    return request({
      url: '/ps/storeStatistics/getAreaStoreAndDevice',
      method: 'get',
      timeout: 20000
    })
  }


// WEBPACK FOOTER //
// ./src/api/storemanagement/storeStatics.js